import { Table, TableTheadProps } from '@mantine/core';
import clsx from 'clsx';
import { forwardRef } from 'react';

export type RegistryTableTheadProps = TableTheadProps;

export const createRegistryTableThead = () => {
	const RegistryTableThead = forwardRef<HTMLTableSectionElement, RegistryTableTheadProps>(
		({ className, ...props }, ref) => (
			<Table.Thead
				ref={ref}
				className={clsx('registry-table-thead', className)}
				{...props}
			/>
		),
	);

	return RegistryTableThead;
};
